import React, {useEffect, useState} from 'react';
import {Box, Button, Typography, AppBar, Toolbar} from '@mui/material';
import {useTheme} from "../../contexts/theme";
import headerLogo from "../../assets/images/Login/inbriefFullWhiteR.svg";
import {useNavigate} from 'react-router-dom';
import {useAuth} from "../../contexts/auth";
import StyledMenu, {MenuOption} from "../StyledMenu/StyledMenu";
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import {UserRole} from "../../types/users";
import GroupIcon from '@mui/icons-material/Group';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

const navItems = [ 'The Matchboard', 'Assets', 'Jobs', 'Dashboard', 'Settings'];



export const Header = ({}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    const auth = useAuth();

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [menuOptions, setMenuOptions] = useState<MenuOption[]>([])

    const handleClose = () => {
        setAnchorEl(null); // chiude il menu
    };

    useEffect(() => {
        let tempMenuOptions = [];
        const isUser = auth.checkUserRoles([UserRole.User])
        const isAdmin = auth.checkUserRoles([UserRole.Admin, UserRole.SuperAdmin])
        const isSuperAdmin = auth.checkUserRoles([UserRole.SuperAdmin])
        if(isUser){
            tempMenuOptions.unshift({
                label: 'Profile',
                icon: <PersonIcon/>
            })
        }

        if(isAdmin){
            tempMenuOptions.push({
                label: 'Users',
                icon: <GroupIcon/>
            })
        }

        if (isSuperAdmin){
            tempMenuOptions.push({
                label: 'Admin Panel',
                icon: <AdminPanelSettingsIcon/>
            })
        }

        tempMenuOptions.push({
            label: 'Log Out',
            icon: <LogoutIcon/>
        })

        setMenuOptions(tempMenuOptions)
    }, [auth.user]);


    const logout = async () => {
        try {
            return await auth.logout()
        } catch (error) {
            console.error("Logout Error");
        }
    };
    const handleRedirect = (name: string) => {
        const routes: Record<string, string> = {
            'The Matchboard': '/matchboard',
            'Assets': '/assets',
            'Dashboard': '/dashboard',
            'Jobs': '/jobs',
            'Users': '/users',
            'Profile': '/users',
            'Admin Panel': '/admin'
        };

        if (name === 'Log Out') {
            logout().then((response) => {
                if (response.message === 'Logout successful') {
                    auth.setAuthenticated(undefined);
                    navigate('/login');
                } else {
                    alert('Logout Error');
                }
            });
        } else {
            const path = routes[name];
            if (path) {
                navigate(path);
            }
        }
    };


    return (
        <Box sx={{display: 'flex'}}>
            <AppBar component="nav" sx={{backgroundColor: theme.palette.blurredBlue,}}>
                <Toolbar sx={{
                    paddingLeft: {
                        xs: theme.spacing.xs,
                        sm: theme.spacing.sm,
                        md: theme.spacing.md,
                        lg: theme.spacing.lg,
                        xl: theme.spacing.xl
                    },
                    paddingRight: {
                        xs: theme.spacing.xs,
                        sm: theme.spacing.sm,
                        md: theme.spacing.md,
                        lg: theme.spacing.lg,
                        xl: theme.spacing.xl
                    }
                }}>
                    <Typography
                        component="div"
                        sx={{flexGrow: 1, display: {xs: 'block'}}}
                    >
                        <img onClick={() => navigate('/matchboard')} src={headerLogo} style={{
                            maxWidth: '150px',
                            height: '100%',
                            paddingTop: theme.spacing.sm,
                            paddingBottom: theme.spacing.sm,
                            objectFit: 'contain',
                            cursor: 'pointer',
                        }}></img>
                    </Typography>

                    <Box sx={{display: {xs: 'none', md: 'block'}, fontSize: {md: theme.fontSizes.description}}}>
                        {navItems.map((item) => (
                            <Button key={item} sx={{
                                fontSize: {
                                    sm: theme.fontSizes.subParagraphTitle,
                                    md: theme.fontSizes.subParagraphTitle,
                                    lg: theme.fontSizes.title
                                },
                                color: theme.palette.white,
                                height: '100%',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }} onClick={() => handleRedirect(item)}>
                                {item === 'Settings' ?
                                    <StyledMenu
                                        onClickItem={(selectedItem => handleRedirect(typeof selectedItem === 'string' ? selectedItem : selectedItem.label))}
                                        options={menuOptions}
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClick={(event)=>setAnchorEl(event.currentTarget)}
                                        onClose={handleClose}
                                    /> :<>{item}</>}
                            </Button>
                        ))}
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
            </nav>
        </Box>
    );
}
